import type { RouteObject } from 'react-router';
import { LazyComponent } from 'components/lazyComponent';

const ListPage = LazyComponent(() => import('./list'));
const CreatePage = LazyComponent(() => import('./create'));
const DetailsPage = LazyComponent(() => import('./details'));
const RunDetailsPage = LazyComponent(() => import('./runDetails'));
const EditPage = LazyComponent(() => import('./edit'));

const routes: RouteObject[] = [{
  path: '/',
  children: [
    { index: true, element: <ListPage /> },
    { path: 'create', element: <CreatePage /> },
    { path: 'details/:id', element: <DetailsPage /> },
    { path: 'details/:id/runs/:runId', element: <RunDetailsPage /> },
    { path: 'edit/:id', element: <EditPage /> },
  ],
}];

export default routes;
